module.exports = {
  'clamp': require('./clamp'),
  'inRange': require('./inRange'),
  'random': require('./random')
};



//////////////////
// WEBPACK FOOTER
// ./~/lodash/number.js
// module id = 252
// module chunks = 0